import { InitClient,GetByParas,Post,PostWithParas,PostNoParas} from "../ZeusAPIClient.js"



//获取休息日数据
// async function GetSchedulingInfoList(paras){
    
//     // return await GetByParas('cd821476-a12a-499c-87be-959191b06380',paras);
//     return await Post('33cc96a0-470f-4fa8-a516-0d068c11dc3a',paras);
// }
async function GetSchedulingInfoList(data){
    
    
    return await PostWithParas('33cc96a0-470f-4fa8-a516-0d068c11dc3a','',data);
}

//新增休息日数据
async function AddSchedulingInfo(data){
    
    return await Post('2add091c-7508-4213-970b-bfb61dd8e973',data);
}


export{   
    GetSchedulingInfoList,
    AddSchedulingInfo,
}